import React from 'react'
import { Mic } from 'lucide-react'

interface ElegantMicSpinnerProps {
  size?: number
  color?: string
}

const ElegantMicSpinner: React.FC<ElegantMicSpinnerProps> = ({
  size = 120, // Increased default size
  color = '#3B82F6'
}) => {
  return (
    <div 
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    >
      {/* Outer rotating ring */}
      <div 
        className="absolute border-4 rounded-full animate-spin"
        style={{ 
          width: size, 
          height: size, 
          borderColor: `${color}40`,
          borderTopColor: color,
          animationDuration: '1.5s'
        }}
      ></div>
      
      {/* Inner pulsing circle */}
      <div 
        className="absolute rounded-full animate-pulse"
        style={{ 
          width: size * 0.6, 
          height: size * 0.6, 
          backgroundColor: `${color}20`,
          animationDuration: '2s'
        }}
      ></div>
      
      {/* Microphone icon */}
      <Mic
        size={size * 0.4}
        color={color}
        className="relative z-10"
      />
    </div>
  )
}

// Wrapper component to center the spinner on the screen
const CenteredSpinner: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <ElegantMicSpinner size={120} color="#E5E7EB" />
    </div>
  )
}

export default CenteredSpinner